import { createContext } from 'react';
/**
 * This just stores the current search result we are 'looking' at.
 */
const SearchResultContext = createContext(undefined);
SearchResultContext.displayName = 'SearchResultContext';
const ArticleContext = createContext(undefined);
ArticleContext.displayName = 'ArticleContext';
const RelatedArticlesContext = createContext(undefined);
RelatedArticlesContext.displayName = 'RelatedArticlesContext';
const ArticleFragmentContext = createContext(undefined);
ArticleFragmentContext.displayName = 'ArticleFragmentContext';
const HomeContext = createContext(undefined);
HomeContext.displayName = 'HomeContext';
const CategoryContext = createContext(undefined);
CategoryContext.displayName = 'CategoryContext';
export { ArticleContext, ArticleFragmentContext, CategoryContext, HomeContext, RelatedArticlesContext, SearchResultContext, };
//# sourceMappingURL=index.js.map